import { render } from "./address-comp.vue?vue&type=template&id=3107a0de&scoped=true"
import script from "./address-comp.vue?vue&type=script&lang=js"
export * from "./address-comp.vue?vue&type=script&lang=js"

import "./address-comp.vue?vue&type=style&index=0&id=3107a0de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3107a0de"]])

export default __exports__